import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import { Panel } from '../../../atoms'
import SidebarLayout from '../../_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  range_tags: {
    range_tags: IJsonResponse
  }
  user: any
}

const COLUMNS = [
  {
    name: I18n.t('generic.name'),
    field: 'name',
    required: true,
  },
  {
    name: I18n.t('generic.position'),
    field: 'position',
    required: false,
  },
]

const RangeTagsIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Range tag')
  const { data, pagination } = agentService.getDataFromJson(props.range_tags.range_tags)
  const { data: userData } = utilService.getDataFromJson(props.user)
  const [rangeTags, setRangeTags] = React.useState(data)
  const handleDelete = React.useCallback(
    async id => {
      const response = await agentService.deleteRangeTag(id)
      window.flashMessages.addMessage({
        text: response.data.flush.message,
        type: response.data.flush.type,
      })
      setRangeTags(rangeTags.filter(rangeTag => rangeTag.id !== id))
    },
    [rangeTags]
  )

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel
          title={
            <Heading>
              <span>{I18n.t('generic.range_tag')}</span>
              <Button small={true}>
                <a href="/agent/range_tags/new">{I18n.t('generic.create_new')}</a>
              </Button>
            </Heading>
          }
        >
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={rangeTags}
            pagination={pagination}
            handleDelete={handleDelete}
            getEditLink={({ id }) => `/agent/range_tags/${id}/edit`}
          />
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Panel {
    max-width: none;
  }
`

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default RangeTagsIndex
